import React from 'react';
// Components
import HomeAboutSection from './HomeAboutSection';
import HomeCommericalSection from './HomeCommericalSection';
import HomeWellnessSection from './HomeWellnessSection';
import ReviewsShortSection from '../reviews/ReviewsShortSection';
import MainCta from '../cta/MainCta';

function HomePageMainContainer() {
  return (
    <main role='main' className='grid gap-y-8 lg:gap-y-12 w-full h-full'>
      <HomeAboutSection />
      <HomeCommericalSection />
      <HomeWellnessSection />
      <ReviewsShortSection />
      <MainCta />
    </main>
  );
}

export default HomePageMainContainer;
